import React from 'react';
import { SchoolCustomizations } from '~/data/useSchoolCustomizations';

type State = {
  schoolCustomizations: SchoolCustomizations;
};
const context = React.createContext<State | undefined>(undefined);

type SchoolCustomizationsProviderProps = {
  children: React.ReactNode;
  schoolCustomizations: SchoolCustomizations;
};
export function SchoolCustomizationProvider(props: SchoolCustomizationsProviderProps) {
  const { schoolCustomizations } = props;

  const value = React.useMemo<State>(() => {
    return { schoolCustomizations };
  }, [schoolCustomizations]);

  return <context.Provider value={value}>{props.children}</context.Provider>;
}
export function useSchoolCustomization() {
  const state = React.useContext(context);
  if (!state) throw new Error('useSchoolCustomization should be used within <SchoolCustomizationProvider />');
  return state;
}
